import { render, staticRenderFns } from "./OptionsView.vue?vue&type=template&id=9a53af32"
import script from "./OptionsView.vue?vue&type=script&lang=js"
export * from "./OptionsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports